import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { throwError, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandler } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Respuesta, UmasData, CalendarioPagoData, CalendarioCatalogo } from '../models';
import { HeadersStore } from '../store/headers.store';
@Injectable({
  providedIn: 'root'
})
export class CatalogosService {


  url = environment.api;
  constructor(private http: HttpClient, private errorHandler: ErrorHandler, private headersStore: HeadersStore) {}

  obtenerCatalogodeCatalgos() {
    return this.http.get(`${this.url}Catalogos`).pipe(
      map((response: Respuesta) => response)
      ,
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al obtener el catalogo de catalogos'));
      })
    );
  }

  obtenerCatalogoUMA() {
    return this.http.get(`${this.url}Catalogos/valorUma`).pipe(
      map((response: Respuesta) => response)
      ,
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al obtener el catalogo de catalogos'));
      })
    );
  }

  obtenerCalendario(){
    if(this.headersStore.GetTKNType() && this.headersStore.GetTKN()){
      return this.obtenerCatalogoCalendario()
    }
    else {
      return of(null);
    }
  }

  obtenerCatalogoCalendario() {
    return this.http.get(`${this.url}Catalogos/calendario`).pipe(
      map((response: Respuesta) => response)
      ,
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al obtener el catalogo de catalogos'));
      })
    );
  }

  obtenerCatalogoSAT() {
    return this.http.get(`${this.url}Catalogos/conceptos-sat`).pipe(
      map((response: Respuesta) => response)
      ,
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al obtener el catalogo de catalogos'));
      })
    );
  }

  addUMA( data: UmasData ) {
    return this.http.post(`${this.url}Catalogos/valorUma`, data)
    .pipe(
      map((response: Respuesta) => response)
    );
  }

  actualizarUMA( data: UmasData ) {
    return this.http.put(`${this.url}Catalogos/valorUma`, data)
    .pipe(
      map((response: Respuesta) => response)
    );
  }

  eliminarUMA( id: number ) {
    return this.http.delete(`${this.url}Catalogos/valorUma/${id}`).pipe(
      map((response: Respuesta) => response)
      ,
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al eliminar UMA'));
      })
    );
  }

  addCalendario( data: CalendarioPagoData ) {
    let form = this.buildCalendario(data, false);
    return this.http.post(`${this.url}Catalogos/calendario`, form).pipe(
      map((response: Respuesta) => response)
      ,
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al agregar calendario'));
      })
    );
  }

  actualizarCalendario( data: CalendarioPagoData ) {
    let form = this.buildCalendario(data, true);
    return this.http.put(`${this.url}Catalogos/calendario`, form).pipe(
      map((response: Respuesta) => response)
      ,
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al actualizar calendario'));
      })
    );
  }

  buildCalendario( data: CalendarioPagoData, Update: boolean = false ) {
    let form : CalendarioCatalogo = {
      periodo: data.mesContable,
      tipo: "",
      mesContable: data.mesContable,
      periodoNominaInicio: data.periodoInicio,
      periodoNominaFin: data.periodoFin,
      limiteInfoColaborador: data.limiteInfoColaborador,
      limiteIncidencias: data.limiteInfoSap,
      limiteInfoSap: data.limiteInfoSap
    };
    if(Update) {
      form['id'] = data? data.id : 0;
    }
    return form;
  }

  eliminarCalendario( id: number ) {
    return this.http.delete(`${this.url}Catalogos/calendario/${id}`).pipe(
      map((response: Respuesta) => response)
      ,
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al eliminar calendario'));
      })
    );
  }

  eliminarConceptoSAT( id: number ) {
    const params = new HttpParams().set('idConceptoSat', id.toString());
    return this.http.delete(`${this.url}Catalogos/conceptos-sat`, { params }).pipe(
      map((response: Respuesta) => response)
      ,
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al eliminar concepto SAT'));
      })
    );
  }

  crearConceptoSAT( data: any ) {
    return this.http.post(`${this.url}Catalogos/conceptos-sat`, data).pipe(
      map((response: Respuesta) => response)
      ,
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al crear concepto SAT'));
      })
    );
  }

  actualizarConceptoSAT( data: any ) {
    return this.http.put(`${this.url}Catalogos/conceptos-sat`, data).pipe(
      map((response: Respuesta) => response)
      ,
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al actualizar concepto SAT'));
      })
    );
  }

}
